module.exports = __webpack_public_path__ + "static/media/educationBooks.4491d298.svg";